export const WorksheetLoanFactsPanelTestIds = {
  PANEL: 'worksheet-drawer.loan-facts',
  SECTION: 'worksheet-drawer.loan-facts.section',
  ROW: 'worksheet-drawer.loan-facts.row',
  VALUE: 'worksheet-drawer.loan-facts.value',
};
